export default class CancelError extends Error {
  constructor(message: string = 'Usuário cancelou a operação.') {
    super(message);
    this.name = 'CancelError';
  }

  static isCancelError(error: Error): boolean {
    return error instanceof CancelError;
  }
}
